import React, { useState } from "react";
import useFetchVesselPrimaryInformation from "../Utils/useFetchVesselPrimaryInformation";
import { ToastContainer, toast } from "react-toastify";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import Skeleton from "react-loading-skeleton";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import "./vesseldetails.css";

const VesselPrimaryInformation = ({ vesselId }) => {
  const { data, isLoading, isError, error } = useFetchVesselPrimaryInformation(vesselId);
  const [collapsedSections, setCollapsedSections] = useState({
    primaryInformation: true,
  });

  const toggleSection = (section) => {
    setCollapsedSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  if (isError) {
    toast.error(error.message || "An error occurred while fetching the vessel primary information.");
    return <div>Error: {error.message}</div>;
  }

  const primaryInformation = data?.data?.primaryInformation;
  const stockedQuantity = data?.data?.stockedQuantity;
  const soldQuantity = data?.data?.soldQuantity;
  const available = data?.data?.available;
  const live = data?.data?.live;

  return (
    <div className="myvessel-details-container">
      <div className="info" onClick={() => toggleSection("primaryInformation")}>
        <p>Primary Information</p>
        {collapsedSections.primaryInformation ? <IoIosArrowDown /> : <IoIosArrowUp />}
      </div>
      {!collapsedSections.primaryInformation && (
        <div className="card">
          <p>
            <strong>Vessel Type</strong> {isLoading ? <Skeleton width={150} /> : primaryInformation?.vesselType || "Not Provided"}
          </p>
          <p>
            <strong>Description</strong> {isLoading ? <Skeleton width={250} /> : primaryInformation?.vesselDescription || "Not Provided"}
          </p>
          <p>
            <strong>Vessel Use</strong> {isLoading ? <Skeleton width={200} /> : (primaryInformation?.vesselUse?.join(", ") || "Not Provided")}
          </p>
          <p>
            <strong>Service Type</strong> {isLoading ? <Skeleton width={150} /> : primaryInformation?.serviceType || "Not Provided"}
          </p>
          <p>
            <strong>Pricing</strong> {isLoading ? <Skeleton width={100} /> : `$${primaryInformation?.pricing || "Not Provided"}`}
          </p>
          <p>
            <strong>Quantity</strong> {isLoading ? <Skeleton width={50} /> : primaryInformation?.quantity || "Not Provided"}
          </p>
          <p>
            <strong>Stocked Quantity</strong> {isLoading ? <Skeleton width={50} /> : stockedQuantity || "Not Provided"}
          </p>
          <p>
            <strong>Sold Quantity</strong> {isLoading ? <Skeleton width={50} /> : soldQuantity || "Not Provided"}
          </p>
          <p>
            <strong>Available</strong> {isLoading ? <Skeleton width={50} /> : available ? "Yes" : "No"}
          </p>
          <p>
            <strong>Live</strong> {isLoading ? <Skeleton width={50} /> : live ? "Yes" : "No"}
          </p>
        </div>
      )}
      <ToastContainer />
    </div>
  );
};

export default VesselPrimaryInformation;
